export const smartSearchConstants = {
  GETALL_REQUEST: "SMARTSEARCH_GETALL_REQUEST",
  GETALL_SUCCESS: "SMARTSEARCH_GETALL_SUCCESS",
  GETALL_FAILURE: "SMARTSEARCH_GETALL_FAILURE",

  GET_CUSTOMERS_FILTERED_BY_NAME: "SMARTSEARCH_GET_CUSTOMERS_FILTERED_BY_NAME",
  GET_CUSTOMERS_FILTERED_BY_USERNAME:
    "SMARTSEARCH_GET_CUSTOMERS_FILTERED_BY_USERNAME",
  GET_CUSTOMERS_FILTERED_BY_PROJECTNAME:
    "SMARTSEARCH_GET_CUSTOMERS_FILTERED_BY_PROJECTNAME",
  GET_CUSTOMERS_FILTERED_BY_SENDER:
    "SMARTSEARCH_GET_CUSTOMERS_FILTERED_BY_SENDER",

  GET_DOCS_EBID_REQUEST: "SMARTSEARCH_GET_DOCS_EBID_REQUEST",
  GET_DOCS_EBID_SUCCESS: "SMARTSEARCH_GET_DOCS_EBID_SUCCESS",
  GET_DOCS_EBID_FAILURE: "SMARTSEARCH_GET_DOCS_EBID_FAILURE",

  GET_DOCS_REQUEST: "SMARTSEARCH_GET_DOCS_REQUEST",
  GET_DOCS_SUCCESS: "SMARTSEARCH_GET_DOCS_SUCCESS",
  GET_DOCS_FAILURE: "SMARTSEARCH_GET_DOCS_FAILURE",

  GET_DOCS_SENDER_REQUEST: "SMARTSEARCH_GET_DOCS_SENDER_REQUEST",
  GET_DOCS_SENDER_NAME_REQUEST: "SMARTSEARCH_GET_DOCS_SENDER_NAME_REQUEST",
  GET_DOCS_SENDER_SUCCESS: "SMARTSEARCH_GET_DOCS_SENDER_SUCCESS",
  GET_DOCS_SENDER_NAME_SUCCESS: "SMARTSEARCH_GET_DOCS_SENDER_NAME_SUCCESS",
  GET_DOCS_SENDER_FAILURE: "SMARTSEARCH_GET_DOCS_SENDER_FAILURE",

  GET_DOCS_RECEIVER_REQUEST: "SMARTSEARCH_GET_DOCS_RECEIVER_REQUEST",
  GET_DOCS_RECEIVER_NAME_REQUEST: "SMARTSEARCH_GET_DOCS_RECEIVER_NAME_REQUEST",
  GET_DOCS_RECEIVER_SUCCESS: "SMARTSEARCH_GET_DOCS_RECEIVER_SUCCESS",
  GET_DOCS_RECEIVER_NAME_SUCCESS: "SMARTSEARCH_GET_DOCS_RECEIVER_NAME_SUCCESS",
  GET_DOCS_RECEIVER_FAILURE: "SMARTSEARCH_GET_DOCS_RECEIVER_FAILURE",

  GET_FILES_REQUEST: "SMARTSEARCH_GET_FILES_REQUEST",
  GET_FILES_SUCCESS: "SMARTSEARCH_GET_FILES_SUCCESS",
  GET_FILES_FAILURE: "SMARTSEARCH_GET_FILES_FAILURE",

  GET_FILES_CUSTOMER_REQUEST: "SMARTSEARCH_GET_FILES_CUSTOMER_REQUEST",
  GET_FILES_CUSTOMER_SUCCESS: "SMARTSEARCH_GET_FILES_CUSTOMER_SUCCESS",
  GET_FILES_CUSTOMER_FAILURE: "SMARTSEARCH_GET_FILES_CUSTOMER_FAILURE",

  GET_FILTERED_CHANNELS: "SMARTSEARCH_GET_FILTERED_CHANNELS",

  GET_BATCHES_REQUEST: "SMARTSEARCH_GET_BATCHES_REQUEST",
  GET_BATCHES_SUCCESS: "SMARTSEARCH_GET_BATCHES_SUCCESS",
  GET_BATCHES_FAILURE: "SMARTSEARCH_GET_BATCHES_FAILURE"
};
